import React, { ReactElement, useState, useEffect } from "react";
import { storage } from "../../apis/firebase";
import { ref, getDownloadURL } from "firebase/storage";

const Image = ({ title, path, ...rest }): ReactElement => {
  const [_title, setIsTitle] = useState("");
  const [_path, setIsPath] = useState("");

  useEffect(() => {
    if (!path) return;
    let mounted = true;
    setIsTitle(title);

    getStorageFileUrl(path).then((d) => {
      if (mounted) setIsPath(d);
    });

    return () => {
      mounted = false;
    };
  }, [path]);

  const getStorageFileUrl = async (url): any => {
    if (!!url) {
      return await getDownloadURL(ref(storage, url));
    }
  };

  return <>{!!_path && <img src={_path} alt={_title} {...rest} />}</>;
};

export default Image;
